const initTestimonials = () => {
  const testimonialSections = document.querySelectorAll(".Testimonials");

  testimonialSections.forEach((section) => {
    const triggers = section.querySelectorAll("[data-tab-trigger]");
    const tabs = section.querySelectorAll("[data-tab]");

    triggers.forEach((t) => {
      t.addEventListener("click", () => {
        setActive(triggers, t.dataset.tabTrigger);
        setActive(tabs, t.dataset.tabTrigger);
      });
    });
  });

  function setActive(group, tabId) {
    group.forEach((element) => {
      element.dataset.tab == tabId || element.dataset.tabTrigger == tabId
        ? element.classList.add("active")
        : element.classList.remove("active");
    });
  }
};

initTestimonials();
